module.exports = __webpack_public_path__ + "static/nslide3-8e647ab9f59f9667061a038e45783463.png";